export default __webpack_public_path__ + "static/media/3.16cbb72b.jpg";